import React, { useEffect, useRef, useState } from "react";
import { animate, useInView, useReducedMotion } from "framer-motion";
import { EASE } from "../utils/motion";
type AnimatedNumberProps = {
  value: number;
  prefix?: string;
  suffix?: string;
  /** Adds thousands separators, e.g. 270,500. */
  grouped?: boolean;
  duration?: number;
};
export function AnimatedNumber({
  value,
  prefix = "",
  suffix = "",
  grouped = false,
  duration = 1.4
}: AnimatedNumberProps) {
  const ref = useRef<HTMLSpanElement>(null);
  const inView = useInView(ref, {
    once: true,
    amount: 0.6
  });
  const reduce = useReducedMotion();
  const [display, setDisplay] = useState(0);
  useEffect(() => {
    if (!inView) return;
    if (reduce) {
      setDisplay(value);
      return;
    }
    const controls = animate(0, value, {
      duration,
      ease: EASE,
      onUpdate: v => setDisplay(Math.round(v))
    });
    return () => controls.stop();
  }, [inView, value, reduce, duration]);
  const formatted = grouped ? display.toLocaleString("en-US") : String(display);
  return <span ref={ref} className="tabular-nums" data-id="element-123" data-mp="3vtwclwrook1x">{prefix}{formatted}{suffix}</span>;
}